import { render } from "./CarsBusinessContainer.vue?vue&type=template&id=204fff90"
import script from "./CarsBusinessContainer.vue?vue&type=script&lang=js"
export * from "./CarsBusinessContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__